import { system } from 'styled-system';

const borderStyle = system({
  borderStyle: {
    property: 'borderStyle',
  },
});

export default borderStyle;
